export default __webpack_public_path__ + "assets/images/leave-review-stars-a0e1dfb3.png";